var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.857 22.2053V33.1359C30.857 33.7132 30.6666 34.2474 30.3453 34.6774C29.8744 35.3074 29.1241 35.7148 28.2781 35.7148H6.19865C5.35155 35.7148 4.60013 35.3074 4.13035 34.6774C4.09595 34.6312 4.06263 34.5839 4.03145 34.5345C3.77023 34.1313 3.61865 33.6508 3.61865 33.1359V11.0564C3.61865 9.63091 4.7732 8.47754 6.19865 8.47754H28.2781C29.2305 8.47754 30.0627 8.99354 30.5087 9.76216L26.959 13.3128L19.103 21.17L13.3807 15.4478C12.3702 14.4373 10.3503 14.4373 9.34195 15.4478L6.98555 17.8032C6.62758 18.1611 6.39645 18.646 6.29325 19.1672C6.1019 20.1165 6.33303 21.1904 6.98555 21.843L17.083 31.9405C18.0925 32.9499 20.1113 32.9499 21.1218 31.9405L23.4782 29.5841L30.857 22.2053Z",
    fill: "#CCE9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6237 14.437L30.8568 22.2051L23.478 29.5839L21.1216 31.9403C20.1111 32.9497 18.0922 32.9497 17.0828 31.9403L6.98534 21.8428C6.33282 21.1903 6.10169 20.1162 6.29304 19.167C6.39624 18.6456 6.62737 18.1609 6.98534 17.803L9.34174 15.4476C10.3501 14.4371 12.37 14.4371 13.3805 15.4476L19.1027 21.1697L26.9588 13.3126L30.5085 9.76196L32.2285 8.04303C33.239 7.03253 35.2589 7.03253 36.2673 8.04303L38.6237 10.3984C38.8989 10.6745 39.0999 11.0251 39.2246 11.4098C39.5589 12.4354 39.3579 13.7028 38.6237 14.437Z",
    fill: "#56C2DF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIcon);
export default __webpack_public_path__ + "static/media/tickIcon.0b08d904b9cac294dcfdf957456486d3.svg";
export { ForwardRef as ReactComponent };